export default __webpack_public_path__ + "static/media/instagram.190bbf3d.svg";